import DashboardBanner from './DashboardBanner'

export default DashboardBanner
